<template>
	<div>
		<el-dialog title="添加" width="700px" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form">
				<el-form-item label="省份" :label-width="formLabelWidth" prop="provinces">
					<el-select size="medium" filterable allow-create v-model="form.provinces" placeholder="请选择" @change="InquireCity">
						<el-option v-for="(item, index) in provincesGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市" :label-width="formLabelWidth" prop="city">
					<el-select size="medium" filterable allow-create v-model="form.city" placeholder="请选择"  @change="InquireArea">
						<el-option v-for="(item, index) in cityGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地区" :label-width="formLabelWidth" prop="area">
					<el-select size="medium" filterable allow-create v-model="form.area" placeholder="请选择">
						<el-option v-for="(item, index) in areaGrouped" :label="item" :value="item" :key="index"></el-option>
					</el-select></el-form-item>
				<el-form-item label="区号" :label-width="formLabelWidth" prop="cityCode">
					<el-input size="medium" v-model="form.cityCode" placeholder="请输入区号" autocomplete="off"></el-input></el-form-item>
				<el-form-item label="局名" :label-width="formLabelWidth" prop="part">
					<el-input size="medium" v-model="form.part" placeholder="请输入局名" autocomplete="off"></el-input></el-form-item>
				<el-form-item label="号码前缀" :label-width="formLabelWidth" prop="partCode">
					<el-input size="medium" v-model="form.partCode" placeholder="请输入号码前缀" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="号码长度" :label-width="formLabelWidth" prop="phoneLen">
					<el-input size="medium" v-model="form.phoneLen" placeholder="请输入号码长度" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" type="primary" :loading="loading" @click="saveThemRoughly('form')">保存</el-button>
				<el-button size="medium" @click="resetForm('form')">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			editType: 1,
			dialogFormVisible: false,
			provincesGrouped: [],
			cityGrouped:[],
			areaGrouped:[],
			form: {
				provinces: '',
				city: '',
				area: '',
				cityCode: '',
				part: '',
				partCode: '',
				phoneLen: '',
				nation: '中国',
				nationCode: '+86'
			},
			rules: {
				provinces: [
					{ required: true, message: '请选择省份！', trigger: 'change' }
				],
				city: [
					{ required: true, message: '请选择城市！', trigger: 'change' }
				],
				area: [
					{ required: true, message: '请选择地区！', trigger: 'change' }
				],
				cityCode: [
					{ required: false }
				],
				part: [
					{ required: true, message: '局名不能为空！', trigger: 'blur,change' }
				],
				partCode: [
					{ required: true, message: '号码前缀不能为空！', trigger: 'blur, change' }
				],
				phoneLen: [
					{ required: true, message: '号码长度不能为空！', trigger: 'blur, change' }
				]
			},
			formLabelWidth: '80px',
			surveyId: '',
			loading: false
		};
	},
	created() {
		this.surveyId = this.$route.query.id;
	},
	mounted() {},
	methods: {
		InquireCity(val){
			// form
			// provinces
			this.form.city = ''
			this.form.area = ''
			this.areaGrouped =[]
			console.log(val)
			let that = this;
			let params = {
				that: this,
				url:`${this.$config.service.samplegetPhoneLibCityGroup}`,
				method: 'POST',
				data: {
					provinces:this.form.provinces
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.cityGrouped = res.resultBody
					} else {
						that.cityGrouped =[]
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		InquireArea(val){
			this.form.area = ''
			console.log(val)
			let that = this;
			let params = {
				that: this,
				url:`${this.$config.service.samplegetPhoneLibAreaGroup}`,
				method: 'POST',
				data: {
					provinces:this.form.provinces,
					city:this.form.city
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						that.areaGrouped = res.resultBody
					} else {
						that.areaGrouped =[]
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogFormVisible = false
		},
		saveThemRoughly(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					let data = this.form;
					let that = this;
					let url = `${this.$config.service.insertPhonelib}`;
					if (this.editType == 1) {
						url = `${this.$config.service.insertPhonelib}`;
					} else {
						url = `${this.$config.service.modifyPhonelib}`;
					}
					let params = {
						that: this,
						url: url,
						method: 'POST',
						data: data,
						cb(res) {
							console.log('查询全部全部字段对照11111', res);
							if (res.code == 0) {
								that.$message.success(res.message);
								that.resetForm(formName)
								that.$emit('saveOk');
							} else {
								that.$message.error(res.message);
							}
						},
						finally() {
							that.loading = false
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		getPhoneLibProviceGroup() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibProviceGroup}`,
				method: 'POST',
				data: {
					id: that.surveyId
				},
				cb(res) {
					console.log('查询全部全部字段对照11111', res);
					if (res.code == 0) {
						let arr = res.resultBody;
						let newArr = arr.filter(function(value, index, self) {
							return self.indexOf(value) === index;
						});
						that.provincesGrouped = newArr;
					} else {
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadVisible() {
			this.editType = 1;
			this.getPhoneLibProviceGroup();
			this.form = {
				provinces: '',
				city: '',
				area: '',
				cityCode: '',
				part: '',
				partCode: '',
				phoneLen: '',
				nation: '中国',
				nationCode: '+86'
			};
			this.dialogFormVisible = true;
		},
		editVisible() {
			this.editType = 2;
			this.getPhoneLibProviceGroup();
			this.dialogFormVisible = true;
		}
	}
};
</script>

<style scoped="scoped" lang="scss"></style>
